// Demo sessions exist only in this browser tab, never in a platform database.
const KEY = 'nur.local-platform-demo.v1';
export const isLocalDemoHost = hostname => ['localhost', '127.0.0.1', '[::1]', '::1'].includes(hostname);

export function resolveDemoMode(location, storage) {
  if (!isLocalDemoHost(location.hostname)) return false;
  const requested = new URLSearchParams(location.search).get('demo');
  try {
    if (requested === 'off') storage.removeItem(KEY);
    if (requested === 'platform') storage.setItem(KEY, '1');
    return requested === 'platform' || (requested !== 'off' && storage.getItem(KEY) === '1');
  } catch { return requested === 'platform'; }
}

let active;
export function isPlatformDemo() {
  if (active === undefined) {
    active = false;
    if (typeof window !== 'undefined' && isLocalDemoHost(window.location.hostname)) {
      try { active = resolveDemoMode(window.location, window.sessionStorage); }
      catch { active = new URLSearchParams(window.location.search).get('demo') === 'platform'; }
    }
  }
  return active;
}

export function demoAdapterOptions() {
  return isPlatformDemo() ? { adapter: async config => {
    const { demoAdapter } = await import('./adapter.js');
    return demoAdapter(config);
  } } : {};
}

export function leavePlatformDemo() {
  // Reload discards the synthetic auth session and all in-memory demo changes.
  window.location.assign('/?demo=off');
}
